import { useTheme } from '@chakra-ui/react';
import React, { useState } from 'react';
import inCompany  from '../../innerAsstes/characteristics/in-company.png'
import trayecto from '../../innerAsstes/characteristics/trayecto.png'
import clases from '../../innerAsstes/characteristics/clases-vivo.png'
import cursos from '../../innerAsstes/characteristics/cursos.png'
import '../../App.css';
import { useAppContext } from '../../App';

const cardsArray = [
  {
    id: 1,
    srcImg: cursos,
    cardText: 'CURSOS 100% ONLINE',
    selected: false
  },
  {
    id: 2,
    srcImg: clases,
    cardText: 'CURSOS CON CLASES EN VIVO',
    selected: false
  },
  {
    id: 3,
    srcImg: trayecto,
    cardText: 'TRAYECTO PROFESIONAL',
    selected: false
  },
  {
    id: 4,
    srcImg: inCompany,
    cardText: 'GESTAR IN COMPANY',
    selected: false
  },
]

export default function Characteristics() {
  const [selection, setSelection] = useState(cardsArray);
  const theme = useTheme();
  const { isMobile } = useAppContext();
  const style = styles(theme, isMobile);
  const handleSelect = (selectedId) => {
    setSelection(
      cardsArray.map( item => ({ 
        ...item,
        selected: item.id === selectedId
      }))
    )
  }
  return (
    <div style={style.container} className='sansation-bold'>
      {selection.map( (item, index) => (
        <div key={`characteristics-nbr-${index}`} style={item.selected? style.imgAndTextActive : style.imgAndTextContainer} onClick={() => handleSelect(item.id)}>
          <img style={style.img} src={item.srcImg} alt={`characteristics-img-${index}`}/>
          <p style={style.text}>{item.cardText}</p>
        </div>
      ))}
    </div>
  )
}

const styles = (theme, isMobile) => ({
  container: {
    display: 'flex',
    flexDirection: isMobile? 'column' : 'row',
    justifyContent: isMobile? 'center' : 'space-between',
    padding: '5vh',
    paddingLeft: '10vh',
    paddingRight: '10vh',
  },
  imgAndTextActive:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: '1px',
    width: isMobile? '95%' : '20%',
    height: isMobile? '20vh' : '20%',
    marginTop: isMobile? '5%' : '1%',
    borderRadius: 20,
    padding: '2vh',
    backgroundColor: 'grey'
  },
  imgAndTextContainer:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: '1px',
    width: isMobile? '95%' : '20%',
    height: '30vh',
    marginTop: isMobile? '5%' : '0%',
    borderRadius: 20,
    padding: '2vh',
  },
  img:{
    display: 'flex',
    height: isMobile? '60%':'10vw',
    justifyContent: 'center',
  },
  text:{
    fontSize: isMobile? '1rem':'1.5rem',
    textAlign: 'center',
    width: '90%',
    color: theme.color.text.primary
  }
})
